import React from 'react';
import './ShippingPolicy.css';

const ShippingPolicy = () => {
  return (
    <div className="footer-page-container6">
      <h1>Shipping Policy</h1>
      
      <div className="footer-page-content6">
        <section className="shipping-section">        
          <p className="shipping-intro">
            At Keshri Store, we strive to provide reliable and efficient shipping services for all our customers.
            This Shipping Policy outlines our procedures, delivery timeframes, and other important information
            regarding the shipment of our products.
          </p>
          
          <h2>1. Processing Time</h2>
          <p>
            All orders are processed within 1-2 business days (Monday through Friday, excluding holidays) after 
            receiving your order confirmation. You will receive a shipping confirmation email with tracking 
            information once your order has been shipped.
          </p>
          
          <h2>2. Age Verification</h2>
          <p>
            Due to the nature of our products, we are legally required to verify that all customers are at least 
            21 years of age. Age verification is completed during checkout and may affect processing time. 
            In some cases, additional verification may be required, which could delay your order.
          </p>
          <p>
            <strong>Important:</strong> A valid ID showing you are at least 21 years old is required for delivery acceptance.
            If you or anyone accepting the package is unable to provide valid ID, the package will be returned to us.
          </p>
          
          <h2>3. Shipping Restrictions</h2>
          <p>
            Due to state and local regulations, we cannot ship tobacco products to certain locations. If you place an order and we are unable to ship to your location, we will notify you promptly and provide a full refund.
          </p>
          <p>
            Please be aware of your local laws and regulations regarding tobacco products before placing an order.
          </p>
          
          <h2>4. Tracking Your Order</h2>
          <p>
            Once your order has been shipped, you will receive a shipping confirmation email containing your tracking number. You can track your package by:
          </p>
          <ul>
            <li>Clicking the tracking link in your shipping confirmation email</li>
            <li>Logging into your account on our website and viewing your order history</li>
            <li>Contacting our customer service team with your order number</li>
          </ul>
          
          <h2>5. Delivery and Signature Requirements</h2>
          <p>
            <strong>All deliveries require an adult signature (21+ years) at the time of delivery.</strong> This is a legal requirement for tobacco products and cannot be waived.
          </p>
          <p>
            If no one is available to sign for the package, the carrier will leave a notice and attempt delivery again on the next business day. After multiple failed delivery attempts, the package may be returned to us.
          </p>
          
          <h2>6. Lost or Damaged Packages</h2>
          <p>
            In the event that your package is lost or damaged during transit, please contact our customer service team within 7 days of the expected delivery date. We will work with the shipping carrier to locate your package or process a replacement or refund.
          </p>
          <p>
            Please note that we are not responsible for packages that are lost or damaged after being marked as "Delivered" by the carrier.
          </p>
          
          <h2>7. Address Changes</h2>
          <p>
            If you need to change your shipping address after placing an order, please contact our customer service team immediately. We will do our best to accommodate your request, but we cannot guarantee that address changes can be made once an order has been processed.
          </p>
          
          <h2>8. Contact Us</h2>
          <p>
            If you have any questions or concerns about our shipping policy, please contact our customer service team:
          </p>
          <address>
          In Front of Mahila Thana<br />
          Gola Bazar, Buxar, Bihar<br />
          Email: keshritobacco.store@gmail.com<br />
          Phone: (+91) 9955059485<br />
          Hours: Monday-Saturday, 9 AM - 7 PM EST
          </address>
        </section>
      </div>
    </div>
  );
};

export default ShippingPolicy; 